<template>
  <el-card class="container">
    <el-row>
      <el-col :span="12" :offset="12" style="text-align: right; padding-right: 60px">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="getCost"
          size="small"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-col>
    </el-row>
    <!--el-row class="div-row">
      <el-col>
        <div ref="bizCostChart" style="height:400px"></div>
      </el-col>
    </el-row-->
    <el-row class="div-row">
      <el-col>
        <div ref='accCostChart' style="height:400px"></div>
      </el-col>
    </el-row>
    <el-row class="div-row">
      <el-col>
        <el-table :data="tableData" border lazy :load="loadDetail" row-key="key"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}" max-height="800">
          <el-table-column prop="business" label="部门" width="120" fixed></el-table-column>
          <el-table-column prop="accountType" label="服务商" width="100" fixed></el-table-column>
          <el-table-column prop="service" label="服务类型" width="180" fixed></el-table-column>
          <el-table-column prop="total" label="总计" width="100" fixed></el-table-column>
          <el-table-column v-for="date of dates" :key="date" :prop="date" :label="date" width="100">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
import moment from 'moment';
import * as echarts from 'echarts';
require('echarts/theme/macarons')
export default {
  data() {
    return {
      dateRange: [],
      accountCost: [],
      serviceCost: [],
			tableData: [],
      bizCost: [],
			dates: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  mounted() {
    let m = moment();
    let e = m.subtract(1, 'days').format('YYYY-MM-DD');
    let s = m.subtract(30, 'days').format('YYYY-MM-DD');
    this.dateRange = [s, e];
    this.getCost();
  },
  methods: {
    async getCost() {
      if (this.dateRange.length < 2) {
        this.$notify({
            title: '警告',
            message: '请选择起止日期',
            type: 'warning'
        })
        return;
      }

      let [start, end] = this.dateRange;

      let url = `/ams/service/cost?start=${start}&end=${end}`;
      let rst = await this.$http.get(url);
      
      this.parseAccountCost(start, end, rst.data.data);
			let data = this.parseCostTableData(start, end, rst.data.data, true);
			this.tableData = data;
    },
    groupBy (xs, key) {
      if (Object.keys(xs).length == 0) {
        return {}
      }

      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    genDates(start, end) {
      let dates = [];
      start = moment(start);
      end   = moment(end);
      while (start <= end) {
        dates.push(start.format('YYYY-MM-DD'));
        start.subtract(-1, 'days')
      }
      this.dates = dates;
      return dates;
    },
    sum(arr) {
      return parseFloat(arr.reduce((a,b)=>a+b).toFixed(2))
    },
    fillData(start, end, data) {

      let dateRange = this.genDates(start, end);

      Object.keys(data).forEach(k => {
        dateRange.forEach(d => {
          data[k][d] = data[k][d] || 0;

        data[k] = Object.keys(data[k]).sort().reduce(
          (obj, key) => {
            obj[key] = data[k][key];
            return obj;
          },
          {}
        );
        })
      })


      return data;
    },
    parseAccountCost(start, end, cost) {

      let accCost = {};

      cost.forEach((c) => {
        let k = `${c.business}-${c.account_type}`;
        accCost[k] = accCost[k] || {};
        accCost[k][c.date] = parseFloat((c.account_type == '腾讯云' ? c.amount / 7 : c.amount).toFixed(2));
      })

      accCost = this.fillData(start, end, accCost);
      accCost = Object.keys(accCost).sort().reduce(
        (obj, key) => {
          obj[key] = accCost[key];
          return obj;
        },
        {}
      );

      this.setChartOption(accCost, 'accCostChart', '每日服务器成本(预估)')

    },
    parseCostTableData(start, end, cost, hasChildren) {

      let svrCost = {};
      let dateRange = this.genDates(start, end);
      let du = {};
      dateRange.forEach(d => du[d] = 0);

      cost.forEach((u) => {

        u.amount = parseFloat((u.account_type == '腾讯云' ? u.amount / 7 : u.amount).toFixed(2))
        let k = `${u.business}:${u.account_type}:${u.service}`;

        svrCost[k] = svrCost[k] || JSON.parse(JSON.stringify(du));
        svrCost[k][u.date] = u.amount;
        svrCost[k]['accountType'] = hasChildren ? u.account_type: '-';
				svrCost[k]['accountId'] = hasChildren ? u.account_id: '-';
        svrCost[k]['business'] = hasChildren ? u.business: '-';
        svrCost[k]['hasChildren'] = hasChildren;
        svrCost[k]['service'] = u.service;
        svrCost[k]['key'] = k;
        svrCost[k]['total'] = svrCost[k]['total'] || 0;
        svrCost[k]['total'] += u.amount;
      })

      svrCost = Object.keys(svrCost).sort().reduce(
        (obj, key) => {
          svrCost[key].total = svrCost[key].total.toFixed(0);
          obj[key] = svrCost[key];
          return obj;
        },
        {}
      );
      return Object.values(svrCost);

    },
    setChartOption(data, ref, title, reverse) {

      let colors = [
        "#5470c6",
        "#9a60b4",
        "#fac858",
        "#ee6666",
        "#ea7ccc",
        "#91cc75",
        "#73c0de",
        "#3ba272",
        "#fc8452",
      ];

      let option = {
        title: {
          text: title,
        },
        grid: {
          top: 60, left: 60, bottom: 60, right: 60
        },
        color: reverse ? colors.reverse() : colors,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            saveAsImage: { show: true }
          }
        },
        legend: {
          data: Object.keys(data),
					bottom: 5,
        },
        xAxis: {
          type: 'category',
          data: Object.keys(data[Object.keys(data)[0]]),
          axisPointer: {
            type: 'shadow'
          },
          axisLine: {
            onZero: false,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        yAxis: {
          type: 'value',
          name: '美元',
          axisLine: {
            onZero: false,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: Object.keys(data).map((k) => {
          return {
            name: k,
            type: 'bar',
            barMaxWidth: '15',
            stack: 'Total',
            showSymbol: false,
            smooth: false,
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: Object.values(data[k])
          }
        })
      };

      let chart = echarts.init(this.$refs[ref]);
      chart.setOption(option);

    },
    async loadDetail(tree, treeNode, resolve) {
    
      let [start, end] = this.dateRange;

      let url = `/ams/service/usage?start=${start}&end=${end}&account_type=${tree.accountType}&account_id=${tree.accountId}&business=${tree.business}`;
      let rsp = await this.$http.get(url);
      let d = this.parseCostTableData(start, end, rsp.data.data, false);
      d.sort((a, b) => b.total - a.total);
      resolve(d);
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  margin: 20px;
}
.div-row {
  margin-top: 30px;
}
</style>
